import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Phone, MessageCircle, Menu, X } from "lucide-react";
import { CONTACT } from "../data/content";
import { track } from "../lib/api";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/experiences", label: "Experiences" },
  { to: "/celebrity-talent", label: "Celebrity & Talent" },
  { to: "/production", label: "Production" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/about", label: "About" },
  { to: "/locations", label: "Locations" },
  { to: "/contact", label: "Contact" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#070708]/85 border-b border-[#C9A55C]/20" data-testid="site-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" className="flex flex-col leading-none" data-testid="brand-logo">
            <span className="font-display text-lg sm:text-xl tracking-[0.18em] text-[#F3EEE5]">MEGA</span>
            <span className="text-[0.55rem] tracking-[0.4em] text-[#C9A55C] uppercase">Celebrity Events</span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7" data-testid="desktop-nav">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `text-[0.7rem] uppercase tracking-[0.2em] transition-colors duration-300 ${
                    isActive ? "text-[#C9A55C]" : "text-[#A9ABB2] hover:text-[#F3EEE5]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href={`tel:${CONTACT.phonePrimaryRaw}`}
              onClick={() => track("call_click", { location: "header" })}
              className="p-2.5 border border-[#C9A55C]/30 text-[#C9A55C] hover:bg-[#C9A55C]/10 transition-colors duration-300 rounded-sm"
              aria-label="Call now"
              data-testid="header-call-btn"
            >
              <Phone size={15} />
            </a>
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track("whatsapp_click", { location: "header" })}
              className="p-2.5 border border-[#C9A55C]/30 text-[#C9A55C] hover:bg-[#C9A55C]/10 transition-colors duration-300 rounded-sm"
              aria-label="WhatsApp"
              data-testid="header-whatsapp-btn"
            >
              <MessageCircle size={15} />
            </a>
            <button
              onClick={() => { track("create_event_click", { location: "header" }); navigate("/plan-your-event"); }}
              className="btn-gold !py-2.5 !px-5"
              data-testid="header-create-event-btn"
            >
              Create Your Event
            </button>
          </div>

          <button
            className="lg:hidden text-[#F3EEE5] p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>

      {open && (
        <div className="fixed inset-0 z-40 bg-[#070708]/98 backdrop-blur-xl pt-24 px-8 lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col gap-6">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-display text-2xl ${isActive ? "text-[#C9A55C]" : "text-[#F3EEE5]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <button
              onClick={() => { setOpen(false); navigate("/plan-your-event"); }}
              className="btn-gold mt-4 w-fit"
              data-testid="mobile-create-event-btn"
            >
              Create Your Event
            </button>
          </nav>
        </div>
      )}
    </>
  );
};
